import {Box, Stack, Typography} from "@mui/material";
import {MensajeDetalle, MensajeDetalleFields, MensajeFields} from "src/pages/messages/types"
import {EntityWithIdFields} from "src/types";
import CustomChip from 'src/@core/components/mui/chip'
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";

export const InfoMensajeMobile = ({message}: { message: MensajeDetalle }) => {
  const {[MensajeDetalleFields.DiasEnEtapa]: diasEnEtapa} = message

  return (
    <Box flexShrink={1} overflow='hidden'>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Stack direction='row' display='flex' alignItems='center' spacing={1} minWidth={0}>
          <CountryAvatar
            countryCode={message[MensajeFields.CodigoSistemaPrincipal]}
            sx={{height: '15px', width: '15px'}}
          />
          <Typography sx={{minWidth: 0}}>
            {message[MensajeFields.NombreSistema]}
          </Typography>
        </Stack>
        <Typography variant='caption'>{`#${message[EntityWithIdFields.Id]}`}</Typography>
      </Box>
      <Stack>
        <Typography noWrap variant='caption' sx={{minWidth: 0, flexShrink: 1}}>
          {message[MensajeFields.Referencia]}
        </Typography>
        <Stack direction='row' spacing={1} display='flex' alignItems='center' justifyContent='space-between'>
          <Typography noWrap variant='caption'>
            <Box component='span' sx={{fontWeight: 600}}>Etapa: </Box>{message[MensajeFields.NombreEtapaActual]}
          </Typography>
          <CustomChip
            size='small'
            skin='light'
            color={diasEnEtapa < 6 ? 'success' : diasEnEtapa < 20 ? 'warning' : 'error'}
            sx={{
              fontSize: 11,
              height: 15
            }}
            label={diasEnEtapa == 0 ? 'hoy' : `hace ${diasEnEtapa} dia${diasEnEtapa > 1 ? 's' : ''}`}
          />
        </Stack>
      </Stack>
    </Box>
  )
}
